import {Map} from '@gongxigames/framework/core';

export class ErrorTypes {
    public static readonly DEPOSIT_CASE_ERROR: number = 112;
    public static readonly LOCAL_ERROR_CODE_MESSAGE_MAP: Map<string> = {
        401: 'error1',
        402: 'error2',
        403: 'error1',
        413: 'error3'
    };
}
